
import uaApple from './ua-apple'
import uaHonor from './ua-honor'
import uaHuawei from './ua-huawei'
import uaOppo from './ua-oppo'
import uaXiaomi from './ua-xiaomi'
import uaVivo from './ua-vivo'
import uaWeixin from './ua-weixin'

export enum DeviceBrand {
  APPLE = 'APPLE',
  XIAO_MI = 'XIAO_MI',
  HUAWEI = 'HUAWEI',
  HONOR = 'HONOR',
  OPPO = 'OPPO',
  VIVO = 'VIVO',
  OTHER = 'OTHER'
}

// 判断是否为苹果品牌
export const isAppleBrand = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  let isApple = uaApple.some(item => userAgent.includes(` ${item} `))
  if (isApple) {
    return true
  }
  isApple = userAgent.match(/iphone/i) !== null
  return isApple
}

// 判断是否为小米品牌
export const isXiaomiBrand = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  let isXiaomi = uaXiaomi.some(item => userAgent.includes(` ${item} `))
  if (isXiaomi) {
    return true
  }
  isXiaomi = userAgent.match(/mi\s/i) !== null
  return isXiaomi
}

// 判断是否为华为品牌
export const isHuaweiBrand = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  let isHuawei = uaHuawei.some(item => userAgent.includes(` ${item} `))
  if (isHuawei) {
    return true
  }
  isHuawei = userAgent.match(/huawei/i) !== null
  return isHuawei
}

// 判断是否为荣耀品牌
export const isHonorBrand = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  let isHonor = uaHonor.some(item => userAgent.includes(` ${item} `))
  if (isHonor) {
    return true
  }
  isHonor = userAgent.match(/honor/i) !== null
  return isHonor
}

// 判断是否为oppo品牌
export const isOppoBrand = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  let isOppo = uaOppo.some(item => userAgent.includes(` ${item} `))
  if (isOppo) {
    return true
  }
  isOppo = userAgent.match(/oppo/i) !== null
  return isOppo
}

// 判断是否为vivo品牌
export const isVivoBrand = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  let isVivo = uaVivo.some(item => userAgent.includes(` ${item} `))
  if (isVivo) {
    return true
  }
  isVivo = userAgent.match(/vivo/i) !== null
  return isVivo
}

// 判断设备品牌
export const checkDeviceBrand = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  if (isAppleBrand(userAgent)) {
    return DeviceBrand.APPLE
  }
  if (isXiaomiBrand(userAgent)) {
    return DeviceBrand.XIAO_MI
  }
  if (isHuaweiBrand(userAgent)) {
    return DeviceBrand.HUAWEI
  }
  if (isHonorBrand(userAgent)) {
    return DeviceBrand.HONOR
  }
  if (isOppoBrand(userAgent)) {
    return DeviceBrand.OPPO
  }
  if (isVivoBrand(userAgent)) {
    return DeviceBrand.VIVO
  }
  return DeviceBrand.OTHER
}

export const isWeixin = (ua?: string) => {
  const userAgent = ua || navigator.userAgent
  let isWeixin = uaWeixin.some(item => userAgent.includes(` ${item} `))
  if (isWeixin) {
    return true
  }
  isWeixin = userAgent.match(/MicroMessenger/i) !== null
  return isWeixin
}